<template>
  <div>
    <div v-if="!ready" class="onboarding-modal-content text-center py-5">
      <div class="svg-container my-3">
        <img
          class="svg svg1"
          :src="require('@/assets/images/megaphone-1.svg')"
        />
        <img
          class="svg svg2"
          :src="require('@/assets/images/megaphone-2.svg')"
        />
      </div>
      <h3 class="mt-5">
        {{ $t('THANK_YOU.TITLE.HOLD_TIGHT') }}
        <span class="dot">.</span>
        <span class="dot">.</span>
        <span class="dot">.</span>
      </h3>
      <span class="my-5">
        {{ $t('THANK_YOU.TEXT.WE_ARE_BUILDING_YOUR_BRAND_NEW_SITE') }}
      </span>
      <div class="my-5"></div>
    </div>
    <div
      v-else
      class="onboarding-modal-content d-flex flex-column align-items-center justify-content-center text-center p-5"
    >
      <img
        class="mt-3"
        :src="require('@/assets/images/flower-illustration.svg')"
      />
      <h3 class="mt-4 mb-0">
        {{ $t('THANK_YOU.TITLE.YOUR_STUDIO_IS_READY') }}
      </h3>
      <span class="mt-3 mb-4 px-5 c-charcoal">
        {{ $t('THANK_YOU.TEXT.STUDIO_IS_READY_DESCRIPTION') }}
      </span>
      <HMButton class="mb-4" color="primary" @click="finish">
        {{ $t('THANK_YOU.BUTTON.GO_TO_MY_STUDIO') }}
      </HMButton>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { errorToMessage } from '../../../../core/utils/errors';
import HMButton from '../../../components/common/HMButton';

export default {
  name: 'StudioPreparingModal',
  components: { HMButton },
  props: {
    onFinish: null,
  },
  computed: {
    ...mapGetters({
      teacher: 'user/teacher',
    }),
  },
  data() {
    return {
      ready: false,
    };
  },
  methods: {
    finish() {
      this.onFinish();
      this.$emit('close');
    },
    async populateStudio() {
      try {
        await this.$store.dispatch('user/populateTeacherStudio');
        this.ready = true;
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Studio initialization failed',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      } finally {
        this.ready = true;
      }
    },
  },
  async mounted() {
    await this.$store.dispatch('user/loadUserInfo');
    if (this.teacher.initialized) {
      this.ready = true;
    }
    this.populateStudio();
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.onboarding-modal-content {
  max-width: 800px;
}

.dot {
  opacity: 0;
  animation: dotFade 3s infinite;
}

.dot:nth-child(1) {
  animation-delay: 0s;
}

.dot:nth-child(2) {
  animation-delay: 0.5s;
}

.dot:nth-child(3) {
  animation-delay: 1s;
}

@keyframes dotFade {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.svg-container {
  display: flex;
  gap: 20px; /* Adjust the gap size as needed */
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}

@keyframes moveElement {
  0% {
    transform: translateX(0) translateY(0);
  }
  50% {
    transform: translateX(20px) translateY(-10px); /* Move 20px horizontally, -10px vertically */
  }
  100% {
    transform: translateX(0) translateY(0);
  }
}

.svg {
  width: 120px;
  height: auto;
}

.svg2 {
  animation: moveElement 1s ease-in-out infinite alternate; /* Adjust animation duration */
}
</style>
